module.exports = __webpack_public_path__ + "img/608.f9ca02fa.jpg";